<video #preview [style.object-fit]="previewFitMode" [poster]="poster">
  <p>
    Your browser does not support this feature, please try to upgrade it.
  </p>
  <p>
    Seu navegador não suporta este recurso, por favor tente atualizá-lo.
  </p>
</video>
